import regeneratorRuntime from "regenerator-runtime";
import {buildConfig} from "./lib"
import Axios from "axios"
if (!process.env.ERO_BACKEND_URL) throw "Environment Variable 'ERO_BACKEND_URL' does not exist or is undefined"

/** 
* Sends contract details to the backend server
* @param {Object} contractDetails - The completed form from reservations component
* @param {String} authToken - JWT token stored in memory
* @return {String} Reference code
*/
export const postSubmittedRentalForm = async (contractDetails,authToken) => {
  let config = buildConfig(authToken);
  let url = `${process.env.ERO_BACKEND_URL}/rental_form/submitted`;
  let response = await Axios.post(url,contractDetails,config);
  return response;
}